var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { mapValidation } from "../../utils/mapValidation";
import { useFormContext, useController, } from "react-hook-form";
/**
 * HOC to wrap hook inputs with UseControllerReturn values
 */
var withFormControl = function (WrappedInput, emptyDefaultValue) {
    var InputComponent = function (_a) {
        var _b = _a.validationArr, validationArr = _b === void 0 ? [] : _b, _c = _a.rules, rules = _c === void 0 ? {} : _c, control = _a.control, passedDefaultValue = _a.defaultValue, hocProps = __rest(_a, ["validationArr", "rules", "control", "defaultValue"]);
        var name = hocProps.name;
        var methods = useFormContext();
        var defaultValue = passedDefaultValue || emptyDefaultValue;
        var mappedValidation = mapValidation(validationArr);
        if (!control && !methods) {
            return _jsx("div", { children: "Input Missing Controller" });
        }
        // use either passed in control, or control from context
        var controllerFields = useController({
            name: name,
            control: control || (methods === null || methods === void 0 ? void 0 : methods.control),
            rules: __assign(__assign({}, rules), { validate: __assign(__assign(__assign({}, mappedValidation), rules.validate), (hocProps.maxLength
                    ? {
                        maxLength: function (val) {
                            if (val.length > hocProps.maxLength) {
                                return "".concat(val.length, "/").concat(hocProps.maxLength, " Characters");
                            }
                            return true;
                        },
                    }
                    : undefined)) }),
            defaultValue: defaultValue,
        });
        return (_jsx(WrappedInput, __assign({}, hocProps, { controllerFields: controllerFields })));
    };
    return InputComponent;
};
export default withFormControl;
